// slope в кг/день → tempo в кг/нед
// Всегда с явным знаком — пользователь должен сразу видеть направление
export function formatTempo(slope: number): string {
  const kgPerWeek = slope * 7
  const abs = Math.abs(kgPerWeek).toFixed(2)
  const sign = slope >= 0 ? '+' : '−'  // '−' (минус) не дефис
  return `${sign}${abs} кг/нед`
}
